import parseLAS from './parse-las';
export default {
  name: 'LAZ',
  extensions: ['las', 'laz'],
  parseSync: parseLAS
};